import { render, staticRenderFns } from "./RoleDrawInviteConfirm.vue?vue&type=template&id=3392c1c8&scoped=true"
import script from "./RoleDrawInviteConfirm.vue?vue&type=script&lang=js"
export * from "./RoleDrawInviteConfirm.vue?vue&type=script&lang=js"
import style0 from "./RoleDrawInviteConfirm.vue?vue&type=style&index=0&id=3392c1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392c1c8",
  null
  
)

export default component.exports